import { useApplicationContainer } from 'containers/ApplicationContainer';
import AdPlaceholder from './AdPlaceholder';
import cn from 'classnames';
import styles from './styles/OutbrainAd.module.scss';
import { OUTBRAIN_ENABLED } from 'constants.js.erb';

export default function OutbrainAd() {
  const [{ canonical, enableOutbrain }] = useApplicationContainer();

  /*if (enableOutbrain !== true) return null;

  return (
    <AdPlaceholder
      className={cn({ [styles.Placeholder]: !OUTBRAIN_ENABLED })}
      data-src={canonical}
      data-widget-id="AR_11"
      placeholder={!OUTBRAIN_ENABLED}
    >
      OutbrainAd ({canonical})
    </AdPlaceholder>
  );*/

  return (
    <AdPlaceholder className={cn({ [styles.Placeholder]: !OUTBRAIN_ENABLED })} id="native-widget" placeholder={!OUTBRAIN_ENABLED}>
      OutbrainAd ({canonical})
    </AdPlaceholder>
  );
}
